
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import CommentSection from "@/components/article/CommentSection";
import ShareButton from "@/components/article/ShareButton";
import ArticleStats from "@/components/article/ArticleStats";
import FaangInterviewContent from "@/components/article/FaangInterviewContent";
import FeedbackSection from "@/components/article/FeedbackSection";

const ArticleFaangInterviews = () => {
  const articleId = 'faang-ml-interviews';
  const articleTitle = "How to Crack Machine learning Interviews at FAANG!";

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow py-8 md:py-12">
        <div className="container max-w-3xl">
          <div className="mb-8">
            <Link to="/learn">
              <Button variant="ghost" className="pl-0 flex items-center gap-2">
                <ArrowLeft size={16} />
                Back to resources
              </Button>
            </Link>
          </div>
          
          <article className="prose prose-lg max-w-none">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">{articleTitle}</h1>
            
            <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-6">
              <span>12 min read</span>
              <span>ML Fundamentals</span>
              
              {/* Article stats (read count, likes) */}
              <ArticleStats 
                articleId={articleId}
                initialReadCount={1256}
                initialLikeCount={341}
              />
            </div>

            <div className="mb-6">
              <img 
                src="https://images.unsplash.com/photo-1488590528505-98d2b5aba04b" 
                alt="Machine Learning Concept" 
                className="w-full rounded-lg"
              />
            </div>
            
            {/* Article content */}
            <FaangInterviewContent />
            
            {/* Share button */}
            <div className="mt-8 flex justify-end">
              <ShareButton title="How to Crack Machine Learning Interviews at FAANG" />
            </div>
            
            {/* Add Feedback Section */}
            <FeedbackSection articleTitle={articleTitle} articleId={articleId} />
          </article>
          
          <CommentSection articleId={articleId} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ArticleFaangInterviews;
